import { Link } from 'react-router-dom';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import ImageIcon from '@material-ui/icons/Image';
import Card from '@material-ui/core/Card';
import PhonelinkLockIcon from '@material-ui/icons/PhonelinkLock';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import InfoIcon from '@mui/icons-material/Info';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import ApartmentIcon from '@mui/icons-material/Apartment';
import React, { useEffect } from 'react';
import ReactSecureStorage from 'react-secure-storage';


const iconStyle = {
  width: 100,
  height: 100,
  color: '#3F598C',
  opacity: '90%',
};

const textStyle = {
  marginTop: '10px',
  fontWeight: '600',
  color: 'rgb(63, 89, 140)',
  opacity: '90%',
};

const cardStyle = {
  padding: '7vh 0',
  margin: '5px',
  minWidth: '200px',
};

const buttonBaseStyle = {
  width: '100%',
  margin: '5px 5px',
  maxWidth: '300px',
};

const Home = () => {
  const memberType = ReactSecureStorage.getItem('memberType');

  const links = [
    { to: '/rokitAdminList', label: 'Admin', Icon: AccountCircleIcon, roles: ['ADMIN'] },
    {
      to: '/distributorAdminList',
      label: 'Distributor',
      Icon: ApartmentIcon,
      roles: ['ADMIN'],
    },
    { to: '/hospitalAdminList', label: 'Hospital', Icon: LocalHospitalIcon, roles: ['ADMIN'] },
    { to: '/template', label: 'Template', Icon: VaccinesIcon, roles: ['ADMIN'] },
    { to: '/regen', label: 'Regen File', Icon: ImageIcon, roles: ['ADMIN'] },
    { to: '/device', label: 'Device', Icon: PhonelinkLockIcon, roles: ['ADMIN'] },
    { to: '/woundMetaList', label: 'Wound Info', Icon: InfoIcon, roles: ['ADMIN'] },
    { to: '/distributorRequestList', 
      label: 'Account',
      Icon: ApartmentIcon, 
      roles: ['DISTRIBUTOR', 'ROKIT_BD'] },
    { to: '/hospitalRequestList', label: 'Hospital', Icon: LocalHospitalIcon, roles: ['DISTRIBUTOR', 'ROKIT_BD'] },
  ];

  let filteredLinks = null;
  if (memberType !== null) {
    filteredLinks = links.filter(link => {
      // ADMIN일 때 제외하고 싶은 링크들
      const excludeForAdmin = [
        '/distributorRequestList',
        '/hospitalRequestList'
      ];

      // memberType이 ADMIN일 때 제외할 링크가 포함되어 있으면 제외
      if (memberType.includes('ADMIN') && excludeForAdmin.includes(link.to)) {
        return false;
      }

      // 기본 필터 조건 유지
      return link.roles.some(role => memberType.includes(role));
    });
  }
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
      }}
    >
      {filteredLinks && filteredLinks.map(({ to, label, Icon }) => {
        return (
          <Link
            key={to}
            to={to}
            style={{
              textDecoration: 'none',
            }}
          >
            <button style={{ ...buttonBaseStyle, fontFamily: 'Pretandard' }}>
              <Card style={cardStyle}>
                <Icon style={iconStyle} />
                <div style={textStyle}>{label}</div>
              </Card>
            </button>
          </Link>
        );
      })}
    </div>
  );
};

export default Home;
